<template>
  <div>
    <search class="search-wrapper" @search="searchHandle" :type="4"/>
    <!--操作栏-->
    <div class="handle_wrapper" >
      <butn
        class="btn-wrapper"
        v-permission="'ticketUser:limitSave'"
        btntype="primary"
        title="新增用户"
        @click.native="addUser"
        :disabled="!!isEnd"
      ></butn>
      <butn
        class="btn-wrapper"
        v-permission="'ticketUser:limitImport'"
        btntype="primary"
        title="导入"
        @click.native="handleImport"
        :disabled="!!isEnd"
      ></butn>
      <butn
        class="btn-wrapper"
        v-permission="'ticketUser:limitExport'"
        btntype="primary"
        title="导出"
        @click.native="exportPage"
      ></butn>
      <butn
        class="btn-wrapper"
        v-permission="'ticketLimit:delete'"
        btntype="primary"
        title="批量移除"
        @click.native="deleteBatch"
        :disabled="!batchDeleteFlag || !!isEnd"
      ></butn>
      <butn
        class="btn-wrapper"
        v-permission="'ticketUser:limitInit'"
        btntype="primary"
        title="数据初始化"
        @click.native="dataInit"
        :disabled="tableData && tableData.length > 0 || !!isEnd"
      ></butn>
    </div>
    <Table
      @selection-change="selectChange"
      :data="tableData"
      :isEnd="isEnd"
      row-key="uuid"
      :type="'4'"
      @handleDetete="handleDetete"
    />
    <div class="RCPagination">
      <RCPagination
        ref="pagination"
        v-model="tableData"
        :startRequest="false"
        :api="api"
      />
    </div>
    <!-- 日程导入 -->
    <ImportModal
      :importDialog="importDialog"
      :uuid="ticketId"
      :type="4"
      @closeDialog="closeImportDialog"
      v-if="importDialog.show"
    />
    <!--新增用户选择-->
    <AddUserModal
      @addSucceed="addSucceed"
      :defaultCheckedKeys="allUsers"
      :uuid="ticketId"
      :type="4"
      :showDirectMemberSelect="showAddUserDialog"
      v-if="showAddUserDialog.flag"
      @closeManage="closeAddUserDialog"
    />
  </div>
</template>
<script>
import {
  ticketUserPage,
  ticketUserLimitDelete,
  limitTicketUserExport,
  limitInit
} from "@/api/resourceService";
import butn from "@/components/button/index";
import { ioRead } from "@/utils/common.js";
import ImportModal from "../importModal.vue";
import Search from "../search";
import Table from "../table.js";
import RCPagination from "@/components/pagination/paginationManage";
import AddUserModal from "../addUserModal.vue";

export default {
  components: {
    ImportModal,
    butn,
    Search,
    Table,
    RCPagination,
    AddUserModal,
  },
  props: {
    ticketId: {
      type: String,
      default: ''
    },
    isEnd: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      api: ticketUserPage,
      tableData: [],
      dataname: {},
      importDialog: { show: false },
      checkArray: [],
      showAddUserDialog: { flag: false },
      allUsers: [],

    };
  },
  computed: {
    batchDeleteFlag() {
      return this.checkArray.length > 0;
    },
  },
  created() {
    //加载列表
    this.$nextTick(() => {
      this.searchHandle();
    });
  },
  methods: {
    // 新增用户
    addUser() {
      this.showAddUserDialog.flag = true;
    },
    closeAddUserDialog() {
      this.showAddUserDialog = { flag: false };
    },
    // 新增用户成功
    addSucceed() {
      this.showAddUserDialog.flag = false;
      this.$refs["pagination"].search(this.dataname);
    },
    
    selectChange(selections) {
      this.checkArray = selections;
    },
    searchHandle(params = {}) {
      this.dataname = {
        ...params,
        ticketId: this.ticketId,
        joinType: 2
      };
      this.$refs["pagination"].search(this.dataname);
    },
    async confirmWay(msg, uuids) {
      try {
        const flag = await this.$confirm(msg, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        if (flag == "confirm") {
          this.fetchDeleteUsers(uuids);
        }
      } catch (error) {}
    },
    // 单个删除
    async handleDetete(row) {
      this.confirmWay("确认删除该用户吗？", [row.uuid])
    },
    // 批量删除
    async deleteBatch() {
      let params = this.checkArray.map((item) => item.uuid);
      this.confirmWay("确认批量删除用户吗？", params)
    },
    fetchDeleteUsers(uuids=[]) {
      ticketUserLimitDelete({ uuids }).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.searchHandle(this.dataname);
      });
    },
    // 用户导入
    handleImport() {
      this.importDialog.show = true;
    },
    // 关闭用户导入窗口
    closeImportDialog(flag) {
      this.importDialog.show = false;
      if (flag) {
        this.searchHandle();
      }
    },
    // 授权用户列表导出
    exportPage() {
      limitTicketUserExport({
        ...this.dataname,
      }).then((response) => ioRead(response));
    },
    // 数据初始化
    dataInit() {
      let params = {
        ticketId: this.ticketId
      }
      limitInit(params).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.searchHandle(this.dataname);
      });
    }

  },
};
</script>
<style lang="scss" scoped>
.search-wrapper {
  float: right;
}
.btn-wrapper {
  margin-left: 0px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.content-top {
  padding-bottom: 20px;
  border-bottom: 1px solid #ececec;
  margin-bottom: 20px;
}
</style>
